$(document).ready(function () {
    initHeaderSticky()
  });
  $(window).resize(function() {
    initHeaderSticky()
  });
  $(window).scroll(function() {
    initHeaderSticky()
  });
  function initHeaderSticky() {
    if (jQuery(document).height() > jQuery(window).height()) {
        if (jQuery('.site-header .main-navigationbar').hasClass("sticky_header")) {
          if (jQuery(this).scrollTop() > 400) {
            jQuery('.site-header .main-navigationbar').addClass("fixed");
          } else {
            jQuery('.site-header .main-navigationbar').removeClass("fixed");
          }
        } else {
          jQuery('.site-header .main-navigationbar').removeClass("fixed");
        }
    }
  }
$(document).ready(function() {
  jQuery('.cart__items-wrapper,.cart__footer-wrapper').wrapAll('<div class="container"><div class="row"></div></div>');
  jQuery('.carthead').prependTo('.template-cart .wrapper > .container > .row');
  countDownIni('.flip-countdown,.js-flip-countdown'); 
  $(".menu-lnk.has-item").hover(function(){
    $(this).toggleClass("menu_active");
    $(this).find(".menu-dropdown").toggleClass("open_menu");
    $("body").toggleClass("no-scroll");
  });
   /********* On scroll heder Sticky *********/
  var prevScrollpos = window.pageYOffset;
  window.onscroll = function () {
    var currentScrollPos = window.pageYOffset;
    if (prevScrollpos > currentScrollPos) {
      document.getElementById("header-sticky").style.top = "0";
    } else {
      document.getElementById("header-sticky").style.top = "-200px";
    }
    prevScrollpos = currentScrollPos;
  }
    /********* Mobile Menu ********/  
      $("#menu").on("click", function () {
        $(".mobile-menu-wrapper, body").toggleClass("active-menu");
      });
      $(".menu-close-icon svg").on("click", function () {
        $(".mobile-menu-wrapper, body").toggleClass("active-menu");
      });
    /********* Cart Popup ********/
        $('.main-cart').on('click', function (e) {
                $('body').addClass('no-scroll cartOpen');
                //$('.overlay').addClass('cart-overlay');
                $('.hmuser').removeClass('active');
            $('.hmuser').next().slideUp('fast');
        });
        $('body').on('click', '.overlay.cart-overlay, .closecart', function (e) {
            //$('.overlay').removeClass('cart-overlay');
            $('body').removeClass('no-scroll cartOpen');
        }); 
        /*********  size Popup  ********/ 
      $(".size-btn").click(function() { 
        $(".size-popup").toggleClass("active"); 
        $("body").toggleClass("no-scroll");
    });
    $(".close-search").click(function() { 
        $(".size-popup").removeClass("active"); 
        $("body").removeClass("no-scroll");
    });
    $(".close-btn").click(function() { 
        $(".size-popup").removeClass("active"); 
        $("body").removeClass("no-scroll");
    });
    /********* Mobile Filter Popup ********/
        $('.mobile-facets__open').on('click', function (e) {
            $('body').addClass('mobile-open no-scroll');
          $('.overlay').addClass('active');
    });
        $('.overlay,.close-filter,.apply-btn').on('click', function (e) {
            $('body').removeClass('mobile-open no-scroll');
          $('.overlay').removeClass('active');
    });
    $('.filter-title').on('click',function(e){
        e.preventDefault();
        setTimeout(function(){
            $('body').addClass('no-scroll filter-open');
            $('.overlay').addClass('active');
        }, 50);
    }); 
    $('body').on('click','.overlay.active, .close-filter', function(e){
        e.preventDefault(); 
        $('.overlay').removeClass('active');
        $('body').removeClass('no-scroll filter-open');
    }); 
    /******* Cookie Js *******/
    $('.cookie-close').click(function () {
        $('.cookie').slideUp();
    });
    /*********  Header Search Popup  ********/ 
    $(".search-header a").click(function() { 
        $(".search-popup").toggleClass("active"); 
        $("body").toggleClass("no-scroll");
        $('.hmuser').removeClass('active');
        $('.hmuser').next().slideUp('fast');
    });
    $(".close-search").click(function() { 
        $(".search-popup").removeClass("active"); 
        $("body").removeClass("no-scroll");
    });
    /******* Subscribe popup Js *******/
    $('.close-sub-btn').click(function () {
        $('.subscribe-popup').slideUp(); 
        $(".subscribe-overlay").removeClass("open");
    });      
    /********* qty spinner ********/
    var quantity = 0;
    $('.quantity-increment').click(function(){;
        var t = $(this).siblings('.quantity');
        var quantity = parseInt($(t).val());
        $(t).val(quantity + 1); 
    }); 
    $('.quantity-decrement').click(function(){
        var t = $(this).siblings('.quantity');
        var quantity = parseInt($(t).val());
        if(quantity > 1){
            $(t).val(quantity - 1);
        }
    });   
    /*********  Multi-level accordion nav  ********/ 
    $('.acnav-label').click(function () {
        var label = $(this);
        var parent = label.parent('.has-children');
        var list = label.siblings('.acnav-list');
        if (parent.hasClass('is-open')) {
            list.slideUp('fast');
            parent.removeClass('is-open');
        }
        else {
            list.slideDown('fast');
            parent.addClass('is-open');
        }
    });  

    // date-labls select 
    $('.date-labls li').on('click', function(){
        $('.date-labls li').removeClass('active')
        $(this).addClass('active');
    });

    $('.time-labls li').on('click', function(){
        $('.time-labls li').removeClass('active')
        $(this).addClass('active');
    });

    /****  TAB Js ****/
    $('ul.tabs li').click(function(){
        var $this = $(this);
        var $theTab = $(this).attr('data-tab');
        console.log($theTab);
        if($this.hasClass('active')){
          // do nothing
        } else{
          $this.closest('.tabs-wrapper').find('ul.tabs li, .tabs-container .tab-content').removeClass('active');
          $('.tabs-container .tab-content[id="'+$theTab+'"], ul.tabs li[data-tab="'+$theTab+'"]').addClass('active');
        }
        $('.bestpro-slider').slick('refresh');
        $('.bestpro-slider-two').slick('refresh');
        $('.bestpro-slider-three').slick('refresh');
    });   
    // HOME BANNER SLIDER JS END // 
    $('.hero-slider-item').slick({
        arrows:false,
        dots: true,
        infinite: true, 
        vertical: false,
        autoplay: true,
        fade: true,
        verticalSwiping: false,
        speed: 2000,
        slidesToShow: 1,
        slidesToScroll: 1, 
        prevArrow: '<button class="slick-prev slick-arrow"><span class="slickbtn"><svg><use xlink:href="#slickarrow"></use></svg></span></button>',
        nextArrow: '<button class="slick-next slick-arrow"><span class="slickbtn"><svg><use xlink:href="#slickarrow"></use></svg></span></button>',
    });  
    // HOME BANNER SLIDER JS END // 
    if($('.client-logo-slider').length > 0 ){
        $('.client-logo-slider').slick({
            autoplay: true, 
            slidesToShow: 5,
            speed: 1000,
            slidesToScroll: 5,  
            arrows:true,
            centerMode: true,
            centerPadding: 0,
            prevArrow: '<button class="slide-arrow slick-prev"><svg width="14" height="6" viewBox="0 0 14 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.48504e-08 3.00044C-4.9681e-06 3.32261 0.261158 3.58378 0.583324 3.58378L11.9791 3.58396L10.6083 4.91557C10.3773 5.14006 10.3719 5.50937 10.5964 5.74045C10.8209 5.97153 11.1902 5.97688 11.4213 5.75239L13.8232 3.41906C13.9362 3.30922 14 3.15829 14 3.00065C14 2.84301 13.9362 2.69208 13.8232 2.58224L11.4213 0.24891C11.1902 0.0244262 10.8209 0.0297744 10.5964 0.260855C10.3719 0.491935 10.3773 0.861243 10.6083 1.08573L11.979 2.41729L0.583343 2.41712C0.261176 2.41711 5.07257e-06 2.67827 3.48504e-08 3.00044Z" fill="#DDE7DE"/></svg></button>',
            nextArrow: '<button class="slide-arrow slick-next"><svg width="14" height="6" viewBox="0 0 14 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.48504e-08 3.00044C-4.9681e-06 3.32261 0.261158 3.58378 0.583324 3.58378L11.9791 3.58396L10.6083 4.91557C10.3773 5.14006 10.3719 5.50937 10.5964 5.74045C10.8209 5.97153 11.1902 5.97688 11.4213 5.75239L13.8232 3.41906C13.9362 3.30922 14 3.15829 14 3.00065C14 2.84301 13.9362 2.69208 13.8232 2.58224L11.4213 0.24891C11.1902 0.0244262 10.8209 0.0297744 10.5964 0.260855C10.3719 0.491935 10.3773 0.861243 10.6083 1.08573L11.979 2.41729L0.583343 2.41712C0.261176 2.41711 5.07257e-06 2.67827 3.48504e-08 3.00044Z" fill="#DDE7DE"/></svg></button>',
            dots: false,
            buttons: false,
            responsive: [ 
                {
                    breakpoint: 1200,
                    settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3   
                    }
                },  
                {
                breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1 
                    }
                }
            ]
        });
    }

    if($('.best-seller-slider').length > 0 ){
        $('.best-seller-slider').slick({
            autoplay: false, 
            slidesToShow: 4,
            speed: 1000,
            slidesToScroll: 4,  
            prevArrow: '<button class="slide-arrow slick-prev"><svg width="14" height="6" viewBox="0 0 14 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.48504e-08 3.00044C-4.9681e-06 3.32261 0.261158 3.58378 0.583324 3.58378L11.9791 3.58396L10.6083 4.91557C10.3773 5.14006 10.3719 5.50937 10.5964 5.74045C10.8209 5.97153 11.1902 5.97688 11.4213 5.75239L13.8232 3.41906C13.9362 3.30922 14 3.15829 14 3.00065C14 2.84301 13.9362 2.69208 13.8232 2.58224L11.4213 0.24891C11.1902 0.0244262 10.8209 0.0297744 10.5964 0.260855C10.3719 0.491935 10.3773 0.861243 10.6083 1.08573L11.979 2.41729L0.583343 2.41712C0.261176 2.41711 5.07257e-06 2.67827 3.48504e-08 3.00044Z" fill="#DDE7DE"/></svg></button>',
            nextArrow: '<button class="slide-arrow slick-next"><svg width="14" height="6" viewBox="0 0 14 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.48504e-08 3.00044C-4.9681e-06 3.32261 0.261158 3.58378 0.583324 3.58378L11.9791 3.58396L10.6083 4.91557C10.3773 5.14006 10.3719 5.50937 10.5964 5.74045C10.8209 5.97153 11.1902 5.97688 11.4213 5.75239L13.8232 3.41906C13.9362 3.30922 14 3.15829 14 3.00065C14 2.84301 13.9362 2.69208 13.8232 2.58224L11.4213 0.24891C11.1902 0.0244262 10.8209 0.0297744 10.5964 0.260855C10.3719 0.491935 10.3773 0.861243 10.6083 1.08573L11.979 2.41729L0.583343 2.41712C0.261176 2.41711 5.07257e-06 2.67827 3.48504e-08 3.00044Z" fill="#DDE7DE"/></svg></button>',
            dots: false,
            buttons: false,
            responsive: [  
                {
                breakpoint:992,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3 
                    }
                } ,
                {
                breakpoint: 768,
                    settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2   
                    }
                },
                {
                breakpoint:576,
                    settings: {
                        slidesToShow:1,
                        slidesToScroll: 1 
                    }
                }
            ]
        });
    }

        if($('.category-blog-slider').length > 0 ){
        $('.category-blog-slider').slick({
            autoplay: false, 
            slidesToShow: 4,
            speed: 1000,
            slidesToScroll: 4,  
            prevArrow: '<button class="slide-arrow slick-prev"><svg width="14" height="6" viewBox="0 0 14 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.48504e-08 3.00044C-4.9681e-06 3.32261 0.261158 3.58378 0.583324 3.58378L11.9791 3.58396L10.6083 4.91557C10.3773 5.14006 10.3719 5.50937 10.5964 5.74045C10.8209 5.97153 11.1902 5.97688 11.4213 5.75239L13.8232 3.41906C13.9362 3.30922 14 3.15829 14 3.00065C14 2.84301 13.9362 2.69208 13.8232 2.58224L11.4213 0.24891C11.1902 0.0244262 10.8209 0.0297744 10.5964 0.260855C10.3719 0.491935 10.3773 0.861243 10.6083 1.08573L11.979 2.41729L0.583343 2.41712C0.261176 2.41711 5.07257e-06 2.67827 3.48504e-08 3.00044Z" fill="#DDE7DE"/></svg></button>',
            nextArrow: '<button class="slide-arrow slick-next"><svg width="14" height="6" viewBox="0 0 14 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.48504e-08 3.00044C-4.9681e-06 3.32261 0.261158 3.58378 0.583324 3.58378L11.9791 3.58396L10.6083 4.91557C10.3773 5.14006 10.3719 5.50937 10.5964 5.74045C10.8209 5.97153 11.1902 5.97688 11.4213 5.75239L13.8232 3.41906C13.9362 3.30922 14 3.15829 14 3.00065C14 2.84301 13.9362 2.69208 13.8232 2.58224L11.4213 0.24891C11.1902 0.0244262 10.8209 0.0297744 10.5964 0.260855C10.3719 0.491935 10.3773 0.861243 10.6083 1.08573L11.979 2.41729L0.583343 2.41712C0.261176 2.41711 5.07257e-06 2.67827 3.48504e-08 3.00044Z" fill="#DDE7DE"/></svg></button>',
            dots: false,
            buttons: false,
            responsive: [  
                {
                breakpoint:992,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                } ,
                {
                breakpoint: 768,
                    settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2   
                    }
                },
                {
                breakpoint:576,
                    settings: {
                        slidesToShow:1,
                        slidesToScroll: 1 
                    }
                }
            ]
        });
    }
  
    if($('.two-colum-slider').length > 0 ){
        $('.two-colum-slider').slick({
            autoplay: false, 
            slidesToShow: 2,
            speed: 1000,
            slidesToScroll: 2,  
            prevArrow: '<button class="slide-arrow slick-prev"><svg width="14" height="6" viewBox="0 0 14 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.48504e-08 3.00044C-4.9681e-06 3.32261 0.261158 3.58378 0.583324 3.58378L11.9791 3.58396L10.6083 4.91557C10.3773 5.14006 10.3719 5.50937 10.5964 5.74045C10.8209 5.97153 11.1902 5.97688 11.4213 5.75239L13.8232 3.41906C13.9362 3.30922 14 3.15829 14 3.00065C14 2.84301 13.9362 2.69208 13.8232 2.58224L11.4213 0.24891C11.1902 0.0244262 10.8209 0.0297744 10.5964 0.260855C10.3719 0.491935 10.3773 0.861243 10.6083 1.08573L11.979 2.41729L0.583343 2.41712C0.261176 2.41711 5.07257e-06 2.67827 3.48504e-08 3.00044Z" fill="#DDE7DE"/></svg></button>',
            nextArrow: '<button class="slide-arrow slick-next"><svg width="14" height="6" viewBox="0 0 14 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.48504e-08 3.00044C-4.9681e-06 3.32261 0.261158 3.58378 0.583324 3.58378L11.9791 3.58396L10.6083 4.91557C10.3773 5.14006 10.3719 5.50937 10.5964 5.74045C10.8209 5.97153 11.1902 5.97688 11.4213 5.75239L13.8232 3.41906C13.9362 3.30922 14 3.15829 14 3.00065C14 2.84301 13.9362 2.69208 13.8232 2.58224L11.4213 0.24891C11.1902 0.0244262 10.8209 0.0297744 10.5964 0.260855C10.3719 0.491935 10.3773 0.861243 10.6083 1.08573L11.979 2.41729L0.583343 2.41712C0.261176 2.41711 5.07257e-06 2.67827 3.48504e-08 3.00044Z" fill="#DDE7DE"/></svg></button>',
            dots: false,
            buttons: false,
            responsive: [  
                {
                breakpoint:1200,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2 
                    }
                } ,
                {
                breakpoint: 992,
                    settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1   
                    }
                },
                {
                    breakpoint:576,
                        settings: {
                            slidesToShow:1,
                            slidesToScroll: 1 
                        }
                    }
            ]
        });
    }

     // testimonials-slider
     $('.testimonial-slider').slick({
        slidesToShow: 3,
       slidesToScroll: 3,
        dots: false,
        infinite: true,
        speed: 1200,
        loop: true,
        arrows: true,
        prevArrow: '<button class="slide-arrow slick-prev"><svg width="14" height="6" viewBox="0 0 14 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.48504e-08 3.00044C-4.9681e-06 3.32261 0.261158 3.58378 0.583324 3.58378L11.9791 3.58396L10.6083 4.91557C10.3773 5.14006 10.3719 5.50937 10.5964 5.74045C10.8209 5.97153 11.1902 5.97688 11.4213 5.75239L13.8232 3.41906C13.9362 3.30922 14 3.15829 14 3.00065C14 2.84301 13.9362 2.69208 13.8232 2.58224L11.4213 0.24891C11.1902 0.0244262 10.8209 0.0297744 10.5964 0.260855C10.3719 0.491935 10.3773 0.861243 10.6083 1.08573L11.979 2.41729L0.583343 2.41712C0.261176 2.41711 5.07257e-06 2.67827 3.48504e-08 3.00044Z" fill="#DDE7DE"/></svg></button>',
        nextArrow: '<button class="slide-arrow slick-next"><svg width="14" height="6" viewBox="0 0 14 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.48504e-08 3.00044C-4.9681e-06 3.32261 0.261158 3.58378 0.583324 3.58378L11.9791 3.58396L10.6083 4.91557C10.3773 5.14006 10.3719 5.50937 10.5964 5.74045C10.8209 5.97153 11.1902 5.97688 11.4213 5.75239L13.8232 3.41906C13.9362 3.30922 14 3.15829 14 3.00065C14 2.84301 13.9362 2.69208 13.8232 2.58224L11.4213 0.24891C11.1902 0.0244262 10.8209 0.0297744 10.5964 0.260855C10.3719 0.491935 10.3773 0.861243 10.6083 1.08573L11.979 2.41729L0.583343 2.41712C0.261176 2.41711 5.07257e-06 2.67827 3.48504e-08 3.00044Z" fill="#DDE7DE"/></svg></button>',
        autoplay: true,
        responsive: [
        {
            breakpoint: 1200,
            settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            },
        },
        {
            breakpoint: 767,
            settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            },
        }
        
    ],
    });


    if($('.blog-slider').length > 0 ){
        $('.blog-slider').slick({
            autoplay: true, 
            slidesToShow: 4,
            speed: 1000,
            slidesToScroll: 4,  
            centerMode: false,
            centerPadding: 0,
            prevArrow: '<button class="slide-arrow slick-prev"><svg width="14" height="6" viewBox="0 0 14 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.48504e-08 3.00044C-4.9681e-06 3.32261 0.261158 3.58378 0.583324 3.58378L11.9791 3.58396L10.6083 4.91557C10.3773 5.14006 10.3719 5.50937 10.5964 5.74045C10.8209 5.97153 11.1902 5.97688 11.4213 5.75239L13.8232 3.41906C13.9362 3.30922 14 3.15829 14 3.00065C14 2.84301 13.9362 2.69208 13.8232 2.58224L11.4213 0.24891C11.1902 0.0244262 10.8209 0.0297744 10.5964 0.260855C10.3719 0.491935 10.3773 0.861243 10.6083 1.08573L11.979 2.41729L0.583343 2.41712C0.261176 2.41711 5.07257e-06 2.67827 3.48504e-08 3.00044Z" fill="#DDE7DE"/></svg></button>',
            nextArrow: '<button class="slide-arrow slick-next"><svg width="14" height="6" viewBox="0 0 14 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.48504e-08 3.00044C-4.9681e-06 3.32261 0.261158 3.58378 0.583324 3.58378L11.9791 3.58396L10.6083 4.91557C10.3773 5.14006 10.3719 5.50937 10.5964 5.74045C10.8209 5.97153 11.1902 5.97688 11.4213 5.75239L13.8232 3.41906C13.9362 3.30922 14 3.15829 14 3.00065C14 2.84301 13.9362 2.69208 13.8232 2.58224L11.4213 0.24891C11.1902 0.0244262 10.8209 0.0297744 10.5964 0.260855C10.3719 0.491935 10.3773 0.861243 10.6083 1.08573L11.979 2.41729L0.583343 2.41712C0.261176 2.41711 5.07257e-06 2.67827 3.48504e-08 3.00044Z" fill="#DDE7DE"/></svg></button>',
            dots: false,
            buttons: false,
            responsive: [  
                {
                breakpoint:1200,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3 
                    }
                },
                {
                breakpoint:768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2 
                    }
                } , 
                {
                breakpoint:576,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1 
                        }
                    }  
            ]
        });
    }

/****  SCROLL COUNTER JS ****/
var isAlreadyRun = false; 
$(window).scroll(function () {
  $(".counter-show").each(function (i) {
    var bottom_of_object = $(this).position().top + $(this).outerHeight() / 2;
    var bottom_of_window = $(window).scrollTop() + $(window).height();

    if (bottom_of_window > bottom_of_object + 20) {
      if (!isAlreadyRun) {
        $(".count-number").each(function () {
          $(this)
            .prop("Counter", 0)
            .animate(
              {
                Counter: $(this).text()
              },
              {
                duration: 3500,
                easing: "swing",
                step: function (now) {
                  $(this).text(Math.ceil(now));
                }
              }
            );
        });
      }
      isAlreadyRun = true;
    }
  });
}); 
/****  SCROLL COUNTER JS End ****/  

   /** PDP slider **/
        $('.pdp-main-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            prevArrow: '<button class="slick-prev slick-arrow"><span class="slickbtn"><svg><use xlink:href="#slickarrow"></use></svg></span></button>',
            nextArrow: '<button class="slick-next slick-arrow"><span class="slickbtn"><svg><use xlink:href="#slickarrow"></use></svg></span></button>',
            infinite: true,
            speed: 1000,
            loop: true,
            asNavFor: '.pdp-thumb-slider',
            autoplay: false,
        });
        $('.pdp-thumb-slider').slick({
            slidesToShow: 5,
            arrows: false,
            asNavFor: '.pdp-main-slider',
            dots: false,
            touchMove: true,
            speed: 1000,
            slidesToScroll: 1,
            touchMove: true,
            focusOnSelect: true,
            loop: true,
            infinite: true,
            vertical: false,
            verticalSwiping: false,
            prevArrow: '<button class="slide-arrow slick-prev"><svg viewBox="0 0 10 5"><path d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
            nextArrow: '<button class="slide-arrow slick-next"><svg viewBox="0 0 10 5"><path d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
            responsive: [
                {
                breakpoint: 768,
                    settings: {
                        vertical: false,
                    }
                }
            ]
        });

        $('.pdp-review-slider').slick({
            dots: false,
            arrows: true,
            slidesToShow: 2,
            slidesToScroll1:2,
            infinite: true,
            speed: 1200,
            autoplay:true,
            loop: false,
            prevArrow: '<button class="slide-arrow slick-prev"><svg width="14" height="6" viewBox="0 0 14 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.48504e-08 3.00044C-4.9681e-06 3.32261 0.261158 3.58378 0.583324 3.58378L11.9791 3.58396L10.6083 4.91557C10.3773 5.14006 10.3719 5.50937 10.5964 5.74045C10.8209 5.97153 11.1902 5.97688 11.4213 5.75239L13.8232 3.41906C13.9362 3.30922 14 3.15829 14 3.00065C14 2.84301 13.9362 2.69208 13.8232 2.58224L11.4213 0.24891C11.1902 0.0244262 10.8209 0.0297744 10.5964 0.260855C10.3719 0.491935 10.3773 0.861243 10.6083 1.08573L11.979 2.41729L0.583343 2.41712C0.261176 2.41711 5.07257e-06 2.67827 3.48504e-08 3.00044Z" fill="#DDE7DE"/></svg></button>',
            nextArrow: '<button class="slide-arrow slick-next"><svg width="14" height="6" viewBox="0 0 14 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.48504e-08 3.00044C-4.9681e-06 3.32261 0.261158 3.58378 0.583324 3.58378L11.9791 3.58396L10.6083 4.91557C10.3773 5.14006 10.3719 5.50937 10.5964 5.74045C10.8209 5.97153 11.1902 5.97688 11.4213 5.75239L13.8232 3.41906C13.9362 3.30922 14 3.15829 14 3.00065C14 2.84301 13.9362 2.69208 13.8232 2.58224L11.4213 0.24891C11.1902 0.0244262 10.8209 0.0297744 10.5964 0.260855C10.3719 0.491935 10.3773 0.861243 10.6083 1.08573L11.979 2.41729L0.583343 2.41712C0.261176 2.41711 5.07257e-06 2.67827 3.48504e-08 3.00044Z" fill="#DDE7DE"/></svg></button>',
           
          });


    // currency
  function currencyFormSubmit(event) {
    event.target.form.submit();
  }

  document.querySelectorAll('.shopify-currency-form select').forEach(function(element) {
    element.addEventListener('change', currencyFormSubmit);
  });

   // coupan code
  $('body').on('keyup','.discount_coupan', function() {
   var apply_href = $('.apply').attr("href").split('discount=')[0];
   var val = $(this).val();
    $('.apply').attr("href",apply_href+'discount='+val);
  });

  // notify me
  $('body').on('click','.notify-btn', function(e) {
      e.preventDefault();
      $('body').addClass('no-scroll notify-active');
      $('.out-of-stock-form,.overlay').addClass('active');
    });
   $('body').on('click','.overlay,.notify-popup-close', function(e) {
      e.preventDefault();
     $('body').removeClass('no-scroll notify-active');
      $('.out-of-stock-form,.overlay').removeClass('active');
    });
  
// quickview
  $('body').on('click', '.quickview-close', function(e) {
    e.preventDefault();
    $('.quickview-popup').hide();
    $('body').removeClass('no-scroll quick-active');
  });
  
  $('body').on('click', '.quickview-btn, .show-qv', function(e) {
    e.preventDefault();
    $('body').addClass('no-scroll quick-active');
    var href= '/products/'+$(this).find('a').data('handle')+'?view=qv';
    $.get(href, function(product) {
      $('.quickview_popup_data').html(product);
      $('.qv_slider').slick({
          autoplay: false,
          slidesToShow: 1,
          speed: 1000,
          slidesToScroll: 1,
          arrows: true,
          prevArrow: '<button class="slide-arrow slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="4" height="6" viewBox="0 0 4 6" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.65976 0.662719C0.446746 0.879677 0.446746 1.23143 0.65976 1.44839L2.18316 3L0.65976 4.55161C0.446747 4.76856 0.446747 5.12032 0.65976 5.33728C0.872773 5.55424 1.21814 5.55424 1.43115 5.33728L3.34024 3.39284C3.55325 3.17588 3.55325 2.82412 3.34024 2.60716L1.43115 0.662719C1.21814 0.445761 0.872773 0.445761 0.65976 0.662719Z" fill="white"></path></svg></button>',
          nextArrow: '<button class="slide-arrow slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="4" height="6" viewBox="0 0 4 6" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.65976 0.662719C0.446746 0.879677 0.446746 1.23143 0.65976 1.44839L2.18316 3L0.65976 4.55161C0.446747 4.76856 0.446747 5.12032 0.65976 5.33728C0.872773 5.55424 1.21814 5.55424 1.43115 5.33728L3.34024 3.39284C3.55325 3.17588 3.55325 2.82412 3.34024 2.60716L1.43115 0.662719C1.21814 0.445761 0.872773 0.445761 0.65976 0.662719Z" fill="white"></path></svg></button>',
          dots: false,
          buttons: false,
          infinite: false,
          loop: false
      });

    });
    $('.quickview-popup').show();
  });

 $('body').on('change', '.nice-select.qv_select__select', function() {
    var selectedValues = [];

    // Collect selected option values
    $('.nice-select.qv_select__select').each(function() {
      var selectedValue = $(this).val();
      if (selectedValue) {
        selectedValues.push(selectedValue);
      }
    });
    var joinedValues = selectedValues.join(' / ');


    $('.variant-qv').each(function() {
     var variant_title = $(this).data('title'); 
     var variant_img = $('.variant-qv[data-title="'+variant_title+'"]').data('img');
     var variant_price = $('.variant-qv[data-title="'+variant_title+'"]').data('price');
     var qv_btn =  $('.variant-qv[data-title="'+variant_title+'"]').data('avail');
     var variant_id = $('.variant-qv[data-title="'+variant_title+'"]').data('id');
      variant_title = String(variant_title);
      joinedValues = String(joinedValues);
      
      if(variant_title === joinedValues){
      var slideIndex = $('.qv_slider .qv-pro-slider-img img[data-img="'+variant_img+'"]').parent().index();
      $('.qv_slider').slick('slickGoTo', slideIndex)
        
        $('.qv-price').find('.price-item--regular').text(variant_price);

        if(qv_btn === true ){
          $('#quick-view-temp .product-form__submit').find('span').text('Add to Cart');
          $('#quick-view-temp .product-form__submit').removeAttr('disabled');
          $('#quick-view-temp .quantity-select').show();
        }else{
          $('#quick-view-temp .product-form__submit').find('span').text('Sold out');
          $('#quick-view-temp .product-form__submit').attr('disabled', 'disabled');
          $('#quick-view-temp .quantity-select').hide();
        }

        $('input[name="id"]').val(variant_id);
        
      }
  });
  
  });
// end quickview

  // custom reviews on product page
  $(window).on('load', function() {
    $(".pdp-left-column").find(".jdgm-prev-badge").append("<a class='product-write-review d-flex align-items-center'><svg xmlns='http://www.w3.org/2000/svg' fill='#000000' id='Outline' viewBox='0 0 24 24' width='16' height='16'><path d='M22.853,1.148a3.626,3.626,0,0,0-5.124,0L1.465,17.412A4.968,4.968,0,0,0,0,20.947V23a1,1,0,0,0,1,1H3.053a4.966,4.966,0,0,0,3.535-1.464L22.853,6.271A3.626,3.626,0,0,0,22.853,1.148ZM5.174,21.122A3.022,3.022,0,0,1,3.053,22H2V20.947a2.98,2.98,0,0,1,.879-2.121L15.222,6.483l2.3,2.3ZM21.438,4.857,18.932,7.364l-2.3-2.295,2.507-2.507a1.623,1.623,0,1,1,2.295,2.3Z'></path></svg> Write a Review</a>");
  });
}); 

if ($(".my-acc-column").length > 0) {
    jQuery(function ($) {
        var topMenuHeight = $("#daccount-nav").outerHeight();
        $("#account-nav").menuScroll(topMenuHeight);
        $(".account-list li:first-child").addClass("active");
    });
    // COPY THE FOLLOWING FUNCTION INTO ANY SCRIPTS
    jQuery.fn.extend({
        menuScroll: function (offset) {
            // Declare all global variables
            var topMenu = this;
            var topOffset = offset ? offset : 0;
            var menuItems = $(topMenu).find("a");
            var lastId;
            // Save all menu items into scrollItems array
            var scrollItems = $(menuItems).map(function () {
                var item = $($(this).attr("href"));
                if (item.length) {
                    return item;
                }
            });
            // When the menu item is clicked, get the #id from the href value, then scroll to the #id element
            $(topMenu).on("click", "a", function (e) {
                var href = $(this).attr("href");
                var offsetTop = href === "#" ? 0 : $(href).offset().top - topOffset;
                function checkWidth() {
                    var windowSize = $(window).width();
                    if (windowSize <= 767) {
                        $('html, body').stop().animate({
                            scrollTop: offsetTop - 200
                        }, 300);
                    }
                    else {
                        $('html, body').stop().animate({
                            scrollTop: offsetTop - 100
                        }, 300);
                    }
                }
                // Execute on load
                checkWidth();
                // Bind event listener
                $(window).resize(checkWidth);
                e.preventDefault();
            });
            // When page is scrolled
            $(window).scroll(function () {
                function checkWidth() {
                    var windowSize = $(window).width();
                    if (windowSize <= 767) {
                        var nm = $("html").scrollTop();
                        var nw = $("body").scrollTop();
                        var fromTop = (nm > nw ? nm : nw) + topOffset;
                        // When the page pass one #id section, return all passed sections to scrollItems and save them into new array current
                        var current = $(scrollItems).map(function () {
                            if ($(this).offset().top - 250 <= fromTop)
                                return this;
                        });
                        // Get the most recent passed section from current array
                        current = current[current.length - 1];
                        var id = current && current.length ? current[0].id : "";
                        if (lastId !== id) {
                            lastId = id;
                            // Set/remove active class
                            $(menuItems)
                                .parent().removeClass("active")
                                .end().filter("[href='#" + id + "']").parent().addClass("active");
                        }
                    }
                    else {
                        var nm = $("html").scrollTop();
                        var nw = $("body").scrollTop();
                        var fromTop = (nm > nw ? nm : nw) + topOffset;
                        // When the page pass one #id section, return all passed sections to scrollItems and save them into new array current
                        var current = $(scrollItems).map(function () {
                            if ($(this).offset().top <= fromTop)
                                return this;
                        });
                        // Get the most recent passed section from current array
                        current = current[current.length - 1];
                        var id = current && current.length ? current[0].id : "";
                        if (lastId !== id) {
                            lastId = id;
                            // Set/remove active class
                            $(menuItems)
                                .parent().removeClass("active")
                                .end().filter("[href='#" + id + "']").parent().addClass("active");
                        }
                    }
                }
                // Execute on load
                checkWidth();
                // Bind event listener
                $(window).resize(checkWidth);
            });
        }
    });
}

function responsiveMenu(){
  if(jQuery(window).width() < 768) {
    $('.product-filter-column').prependTo('.product-heading-row');
  }
  else { 
    $('.product-filter-column').prependTo('.product-list-row');
  }
}
jQuery(document).ready(function() {
  responsiveMenu();
});

jQuery(window).resize(function() {
  responsiveMenu();
});

/******  STEPPY FORM  CSS  ******/
var totalSteps = $(".steps li").length;
$(".submit").on("click", function(){
  return false; 
});

$(".steps li:nth-of-type(1)").addClass("active");
$(".myContainer .step-container:nth-of-type(1)").addClass("active");

$(".step-container").on("click", ".next", function() { 
  $(".steps li").eq($(this).parents(".step-container").index() + 1).addClass("active"); 
  $(this).parents(".step-container").removeClass("active").next().addClass("active"); 
  $('.right-slider').slick('refresh');  
});

$(".step-container").on("click", ".back", function() {  
  $(".steps li").eq($(this).parents(".step-container").index() - totalSteps).removeClass("active"); 
  $(this).parents(".step-container").removeClass("active").prev().addClass("active"); 
  $('.right-slider').slick('refresh');
}); 
/******  STEPPY FORM  CSS  End******/
function countDownIni(countdown) {
  $(countdown).each(function () {
    var countdown = $(this);
    var promoperiod;
    if (countdown.attr('data-promoperiod')) {
      promoperiod = new Date().getTime() + parseInt(countdown.attr('data-promoperiod'), 10);
    } else if (countdown.attr('data-countdown')) {
      promoperiod = countdown.attr('data-countdown');
    }
    if (Date.parse(promoperiod) - Date.parse(new Date()) > 0) {
      $(this).addClass('countdown-block');
      countdown.countdown(promoperiod, function (event) {
        // countdown.html(event.strftime('%-w weeks %-d days %Hh %Mm %Ss'));
        countdown.html(event.strftime('<span><span>%D</span><span class="dots"> : </span></span>' + '<span><span>%H</span><span class="dots"> : </span></span>' + '<span><span>%M</span><span class="dots"> : </span></span>' + '<span><span class="second">%S</span></span>'));
      });
    }

  });
}